import React from 'react';
import css from './WineryPlansPage.module.css';

const Plans = ({plans, plansLoading, handleOnClickSubscribe}) => {
  if(plansLoading) return <p>Loading...</p>
  return (
    <div className={css.plansWrapper}>

        <div className={css.plan}>
          <div>
            <div className={css.contentHeader}>
              <h2>{plans[0].name}</h2>
              <h1>{plans[0].price === 0 ? "FREE" : (plans[0].price)}</h1>
            </div>
            <p>{plans[0].description}</p>
            <ul>
              {plans && Object.keys(plans[0].features).map((k, index) => (
                <li key={index}>{plans[0].features[k]}</li>
              ))}
            </ul>
          </div>
          <div className={css.planBtnWrapper}>
              <button
                onClick={handleOnClickSubscribe}
                className={css.planBtn}
              >
                Subscribe
              </button>
          </div>
        </div>

        <div className={css.plan}>
          <div>
            <div className={css.contentHeader}>
              <h2>{plans[1].name}</h2>
              <h1>${plans[1].price}/mo</h1>
              {/* <span>{plans[1].quotes[0]}</span> */}
            </div>
            <p>{plans[1].description}</p>
            <ul>
              <li>Everything offered in Basic</li>
              {plans && Object.keys(plans[1].features).map((k, index) => (
                <li key={index}>{plans[1].features[k]}</li>
              ))}
            </ul>
            <div className={css.offer}>{plans[1].quotes[1]}</div>
          </div>

          <div className={css.planBtnWrapper}>
              <button
                onClick={handleOnClickSubscribe}
                className={css.planBtn}
              >
                Subscribe
              </button>
          </div>
        </div>

        <div className={css.plan}>
          <div>
            <div className={css.contentHeader}>
              <h2>{plans[2].name}</h2>
              <span>{plans[2].quotes[0]}</span>
              <h1>${plans[2].price}/mo</h1>
            </div>
            <p>{plans[2].description}</p>
            <ul>
              <li>Everything offered in Basic + Grow</li>
              {plans && Object.keys(plans[2].features).map((k, index) => (
                <li key={index}>{plans[2].features[k]}</li>
              ))}
            </ul>
          </div>
          <div className={css.planBtnWrapper}>
              <button
                className={css.planBtn}
                onClick={handleOnClickSubscribe}
              >
                Subscribe
              </button>

          </div>
        </div>

      </div>
  )
}
export default Plans;
